import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletDepositIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.8477 3.10938H3.54762C1.86447 3.10938 0.5 4.47384 0.5 6.15699V17.4525C0.5 19.1357 1.86446 20.5002 3.54762 20.5002H16.5822C18.2654 20.5002 19.6299 19.1357 19.6299 17.4525V6.15699C19.6299 4.47384 18.2654 3.10938 16.5822 3.10938H10.0649",
			stroke: "#4A9167",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8184 3.35254L14.8184 20.4602",
			stroke: "#4A9167",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.45703 0.5V15.2822",
			stroke: "#4A9167",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.87337 12.015L6.91828 15.0599C7.21583 15.3574 7.69824 15.3574 7.99578 15.0599L11.0407 12.015",
			stroke: "#4A9167",
			strokeLinecap: "round"
		})
	]
});
export default SvgWalletDepositIcon;
